<div class="w-full -z-1 relative h-full" [ngClass]="!showvideoHome ? '' : ''">
	<app-carousel *ngIf="showvideoHome == false && images.length > 0 && images[0].url != null" [images]="images"></app-carousel>
</div>